export const CSS_VARIABLE_PREFIX = '--custom-color-';
export const SAVED_COLORS_STYLE_TAG_ID = 'saved-colors';
